const PersonalExchangeList = () => import('Views/personalExchange/personalExchange-list-new-ui');
const PersonalExchangeEdit = () => import('Views/personalExchange/personalExchange-edit-new-ui');
const PersonalExchangeDetail = () => import('Views/personalExchange/personalExchange-detail-new-ui');

export default[
  { path: '/personalExchange-list', component: PersonalExchangeList },
  { path: '/personalExchange-list', component: PersonalExchangeList },
  { path: '/personalExchange-edit/:id', component: PersonalExchangeEdit },
  { path: '/personalExchange-detail/:id', component: PersonalExchangeDetail },
];



// WEBPACK FOOTER //
// ./src/router/personalExchange.js